import { PagedResponse, UserVoucher, Voucher } from 'us-web-services';
import { DateFormat, formatDateFromString } from 'us-react-components/dist/utils/date';
import {
  namespaces,
  useSharedTranslation,
} from 'us-react-components/dist/hooks/useSharedTranslation';

type Props = {
  active?: boolean;
  userVouchers?: PagedResponse<UserVoucher>;
}

export const VoucherItem = ({ userVouchers, active = true }: Props): JSX.Element | null => {
  const { t } = useSharedTranslation(namespaces.caregiver);

  function getVoucherValueText(voucher?: Voucher): string {
    if (voucher?.percentDiscount) {
      return `${voucher.value}% ${t('pages.credits.off')}`;
    }
    return `$${voucher?.value}`;
  }

  function getExpirationDate(date: string | null): string {
    if (!date) return '';

    const fDate = formatDateFromString(date, DateFormat.DATE_FULL_FORMAT);

    return fDate ? `${t('pages.credits.creditExpires')} ${fDate}` : '';
  }

  return (
    <ul>
      {userVouchers?.data?.data?.map(v => (
        <li key={v.voucher?.id} className='odd:bg-neutral-200 p-4 grid grid-cols-2'>
          <div>
            <p className='text-base'>
              {v.voucher?.code}: {v.voucher?.description && v.voucher.description}
            </p>
            <p className='text-base font-semibold'>
              Value: {getVoucherValueText(v.voucher)}
              {active &&
                v.currentValue &&
                !v?.voucher?.percentDiscount &&
                ` ($${v.currentValue} ${t('pages.credits.remaining')})`}
            </p>
          </div>
          {active ? (
            <div className='text-sm'>{getExpirationDate(v.validUntil || '')} </div>
          ) : (
            ''
          )}
        </li>
      ))}
    </ul>
  );
};
